import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import FullBodyContentView from '../../views/fullBodyContentView';
import {useTranslation, withTranslation, Trans} from 'react-i18next';

function GasLinear({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit});
    });
  }, [onExit]);

  const {t, i18n} = useTranslation();
  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
  };

  return (
    <FullBodyContentView
      title={t('gasLinearization.title')}
      fullCaption={
        <>

        <div style={{paddingTop: "17px"}}>{t('gasLinearization.a1')}<span style={{paddingLeft: "72px"}}>Off</span></div>
        <hr style={{ position: "absolute", borderTop: "dotted 2px #000", borderBottom: "none", left: 0, width: "100vw", overflow: "hidden", backgroundColor: "transparent"}}></hr>
        <div style={{paddingTop: "17px"}}>{t('gasLinearization.a2')}<span style={{paddingLeft: "57px"}}>0 gram/s</span></div>
        <hr style={{ position: "absolute", borderTop: "dotted 2px #000", borderBottom: "none", left: 0, width: "100vw", overflow: "hidden", backgroundColor: "transparent"}}></hr>
        <div style={{paddingTop: "17px"}}>{t('gasLinearization.a3')}<span style={{paddingLeft: "59px"}}>0 </span></div>
        <hr style={{ position: "absolute", borderTop: "dotted 2px #000", borderBottom: "none", left: 0, width: "100vw", overflow: "hidden", backgroundColor: "transparent"}}></hr>
        <div style={{paddingTop: "17px"}}>{t('gasLinearization.a4')}<span style={{paddingLeft: "73px"}}>0 gram/s</span></div>
        <hr style={{ position: "absolute", borderTop: "dotted 2px #000", borderBottom: "none", left: 0, width: "100vw", overflow: "hidden", backgroundColor: "transparent"}}></hr>
        <div style={{paddingTop: "17px"}}>{t('gasLinearization.a5')}<span style={{paddingLeft: "38px"}}>On</span></div>
          <hr style={{ position: "absolute", borderTop: "dotted 2px #000", borderBottom: "none", left: 0, width: "100vw", overflow: "hidden", backgroundColor: "transparent"}}></hr>

        </>
      }
    />
  );
}

export default GasLinear;
